/* eslint-disable no-unreachable */
import React from 'react';
import ReactDOM from 'react-dom';
import SwipeableViews from 'react-swipeable-views';
import ResizeObserver from 'resize-observer-polyfill';

export default class MySwipeableViews extends React.Component {
  constructor(props) {
    super(props);

    this.container = React.createRef();
  }

  // componentWillReceiveProps(nextProps) {
  //     let filteredChildren = [];
  //     React.Children.forEach(nextProps.children, (child) => {
  //         if (child !== undefined && child !== null){
  //             filteredChildren.push(child);
  //         }
  //     });
  //     this.setState({filteredChildren: filteredChildren});
  // }

  componentDidMount() {
    // animateHeight measures each slide once, before async content (Chart.js
    // canvases, images) has rendered — leaving the container too short on first
    // load. Re-measure when slide content resizes, plus a few deferred passes to
    // catch the initial async render. See adjustSlideHeights below.
    this.observeSlideContent();
    this.initialAdjustTimers = [100, 300, 600].map(delay => setTimeout(this.adjustSlideHeights, delay));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.index !== this.props.index) {
      this.lastContentHeight = undefined;
      this.adjustSlideHeights();
    }
    // The set of rendered slides can change (e.g. Safari export mode); keep the
    // ResizeObserver pointed at the current slide-content nodes — but only
    // reconnect when those nodes actually change. Re-observing on every parent
    // re-render immediately fires ResizeObserver and can ratchet animateHeight.
    this.observeSlideContent();
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
    if (this.initialAdjustTimers) {
      this.initialAdjustTimers.forEach(clearTimeout);
    }
  }

  observeSlideContent = () => {
    if (typeof ResizeObserver === 'undefined') {
      return;
    }
    const rootNode = this.container.current && ReactDOM.findDOMNode(this.container.current);
    if (!rootNode) {
      return;
    }
    const slideContainer = rootNode.querySelector('.react-swipeable-view-container') || rootNode;
    if (!this.resizeObserver) {
      // updateHeight() only re-measures the active slide, so observing every
      // slide's content and re-measuring is safe and loop-free (it changes the
      // outer container height, not the observed content height). Defer to rAF so
      // the re-measure happens after layout, avoiding the ResizeObserver loop warning.
      this.resizeObserver = new ResizeObserver(() => {
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
        }
        this.rafId = requestAnimationFrame(this.adjustSlideHeights);
      });
    }
    const contents = Array.from(slideContainer.children).map(slide => slide.firstElementChild || slide);
    const sameNodes =
      this.observedNodes &&
      this.observedNodes.length === contents.length &&
      this.observedNodes.every((node, index) => node === contents[index]);
    if (sameNodes) {
      return;
    }
    this.observedNodes = contents;
    this.resizeObserver.disconnect();
    contents.forEach(content => {
      if (content) {
        this.resizeObserver.observe(content);
      }
    });
  };

  // Public alias used by parent views (Share, etc.). Must not throw when the
  // inner SwipeableViews ref has not attached yet or has already unmounted.
  updateHeight = () => {
    this.adjustSlideHeights();
  };

  adjustSlideHeights = () => {
    if (this.container && this.container.current && this.container.current.updateHeight) {
      const rootNode = ReactDOM.findDOMNode(this.container.current);
      const activeSlide = rootNode && rootNode.querySelector('[data-swipeable="true"][aria-hidden="false"]');
      const content = activeSlide && activeSlide.children[0];
      if (content) {
        const nextHeight = content.offsetHeight;
        if (nextHeight === this.lastContentHeight) {
          return;
        }
        this.lastContentHeight = nextHeight;
      }
      this.container.current.updateHeight();
    }
    return;

    let currentIndex = this.props.index;
    // this.container.current.updateHeight();
    // return;

    let slideNodes = this.props.children.map((child, index) => {
      return ReactDOM.findDOMNode(this.refs[index]);
    });

    // console.log('slideNodes', slideNodes);

    let partitioned = slideNodes.reduce(
      (accumulator, slideNode, index) => {
        accumulator[currentIndex === index ? 0 : 1].push(slideNode);
        return accumulator;
      },
      [[], []]
    );

    // console.log('partitioned', partitioned);

    let current = partitioned[0][0];
    let others = partitioned[1];

    // console.log('current', current);
    // console.log('current.offsetHeight', current.offsetHeight);

    if (current !== undefined) {
      if (current.style.height !== '' && this.props.savingAnnuityHeight === undefined) {
        current.style.height = 'fit-content';
      }

      let targetHeight = current.offsetHeight;

      // console.log('targetHeight', targetHeight);

      if (others !== null && others !== undefined && others.length > 0) {
        others.forEach(elem => {
          if (this.props.savingAnnuityHeight === undefined) {
            elem.style.height = targetHeight + 'px';
            // console.log(elem, elem.style.height);
          }
        });
      }

      if (this.props.savingAnnuityHeight === undefined) {
        current.style.height = targetHeight + 'px';
        // current.closest('.react-swipeable-view-container').style.height = targetHeight + 'px';
      }
    }
  };

  // handleException() {
  // 	// handle some exceptions
  // 	console.log(event)
  // 	console.log(document.querySelector('.rc-slider').contains(event.target))
  // 	if (document.querySelector('.rc-slider').contains(event.target)) {
  // 		event.stopPropagation();
  // 	}
  // }

  render() {
    const {
      index,
      onChangeIndex,
      children,
      onSwitching,
      onTransitionEnd,
      threshold,
      disabled,
      enableMouseEvents,
      className,
      style,
      slideStyle
    } = this.props;

    return (
      <SwipeableViews
        className={className}
        ref={this.container}
        disabled={disabled}
        index={index}
        onChangeIndex={index => {
          if (onChangeIndex !== undefined && typeof onChangeIndex === 'function') {
            onChangeIndex(index);
          }
        }}
        onSwitching={onSwitching}
        onTransitionEnd={onTransitionEnd}
        enableMouseEvents={enableMouseEvents !== undefined ? enableMouseEvents : true}
        disableLazyLoading={true}
        ignoreNativeScroll={true}
        threshold={threshold}
        animateHeight={true}
        style={style}
        slideStyle={slideStyle}
      >
        {React.Children.map(children, (element, idx) => {
          if (element) {
            return React.cloneElement(element, { ref: idx });
          } else {
            return '';
          }
        })}
      </SwipeableViews>
    );
  }
}
